import ConstructionCostManagement from "./ConstructionCostManagement";

function AdminDashboard() {
  return <ConstructionCostManagement />;
}

export default AdminDashboard;

